let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aUP3I")).then(() => parcelRequire('9DjFp'));